import React from 'react'

const About = () => {
  return (
    <section id="about">
      <h2 className="l-heading is-subhead is-center m-2 pt-1">About</h2>
      <div className="about-content mx-3">
        <div className="about-img"></div>
        <div className="about-text">
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit,
             sed do eiusmod tempor incididunt ut labore et dolore 
             magna aliqua. Tortor at risus viverra adipiscing at in 
             tellus integer. Quis lectus nulla at volutpat diam ut 
             venenatis tellus in. Tempus egestas sed sed risus 
             pretium quam. Est sit amet facilisis magna etiam tempor 
             orci eu.
          </p>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit,
             sed do eiusmod tempor incididunt ut labore et dolore magna
            aliqua. Ipsum dolor sit amet consectetur adipiscing elit 
            duis. Ac placerat vestibulum lectus mauris ultrices eros in. 
            Sollicitudin aliquam ultrices sagittis orci a scelerisque.
          </p>
        </div>
      </div>
    </section>
  )
}

export default About
